import axios from 'axios'

const handleApplyLaserProfile = (props) => {
}


export const rtlss_api = async (options) => {
    const { _url, isLocal, method, data } = options
    const url = isLocal ?
        `http://localhost:8000${_url}` :
        `api${_url}`

    try {
        const response = await axios({ method, url, data, withCredentials: true })
        return response.data
    } catch (err) {
        if (err.response) {
            return {
                data: null,
                error: err.response.data?.error || err.message,
                message: err.response.data?.message || 'Server responded with an error.'
            }
        } else if (err.request) {
            // No response recvd.
            return {
                data: null,
                error: 'No response from server.',
                message: 'Unexpected error occured.'
            }
        } else {
            // something else has happended setting up the request.
            return {
                data: null,
                error: err.message,
                message: 'Unexpected error occured.'
            }
        }
    }
}


export default { rtlss_api, handleApplyLaserProfile }

